module.exports = __webpack_public_path__ + "static/media/onda-fondo-rosa-rojo-aon-1.80cebebc.png";